import React from 'react'
import styles from "./ScrenningResume.module.css";
import heroImg from "../../../Images/resumescreening.png"
function ScrenningResume() {
    return (
        <section className={styles.talentSection}>
            <div className={styles.container}>

                {/* Left Image */}
                <div className={styles.left}>
                    <img src={heroImg} alt="AI Talent Sourcing Illustration" />
                </div>

                {/* Right Content */}
                <div className={styles.right}>
                    <h2>Start Screening Resumes <br /> Smarter with AI</h2>

                    <p>
                        Stop spending hours reviewing resumes manually. Let ToxBox AI automate resume <br />
                        parsing, ranking, and shortlisting, so you can hire the best candidates faster.
                    </p>

                    <button className={styles.btn}>Get Started Now</button>
                </div>

            </div>
        </section>
    )
}

export default ScrenningResume
